import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { PriceAdjustmentResponseSchema } from "../response/PriceAdjustmentResponse";

const API_VERSION = 'v4';

interface PriceAdjustmentProps {
    filter: {
        property_id?: string;
        date?: {
            gte: string;
            lte: string;
        };
    };
}

export const usePriceAdjustment = ({ filter }: PriceAdjustmentProps) => {
    return useQuery({
        queryKey: ['price-adjustment', filter],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/price-adjustment`, {
                    params: {
                        filter: {
                            ...filter,
                            date: filter.date ? {
                                gte: filter.date.gte,
                                lte: filter.date.lte,
                            } : undefined,
                        }
                    }
                });

                // Validasi respons API
                const validationResult = PriceAdjustmentResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Price Adjustment data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch price adjustment data`, error);
                throw error;
            }
        },
        enabled: !!filter.date?.gte && !!filter.date?.lte,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};